import {
  FUNNEL_STAGES,
  type FunnelStage,
  type OnboardingFunnel,
} from "@/services/admin";

/** 90 seconds -> "1m 30s"; 3 hours 5 min -> "3h 5m"; 2 days -> "2d". */
export function formatDuration(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return "No data yet";
  const totalSeconds = Math.round(ms / 1000);
  if (totalSeconds < 60) return `${totalSeconds}s`;
  const minutes = Math.floor(totalSeconds / 60);
  if (minutes < 60) {
    const s = totalSeconds % 60;
    return s ? `${minutes}m ${s}s` : `${minutes}m`;
  }
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    const m = minutes % 60;
    return m ? `${hours}h ${m}m` : `${hours}h`;
  }
  return `${Math.floor(hours / 24)}d`;
}

/** Share of the previous stage, or null for the first stage / an empty one. */
export function stepShare(
  totals: OnboardingFunnel["totals"],
  stage: FunnelStage
): number | null {
  const i = FUNNEL_STAGES.indexOf(stage);
  if (i <= 0) return null;
  const previous = totals[FUNNEL_STAGES[i - 1]!];
  if (!previous) return null;
  return Math.round((totals[stage] / previous) * 100);
}
